export { default } from './GetCSRFToken';
